var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.results && _vm.generalInfo)?_c('div',{},[_c('div',{staticClass:"font-weight-600 ml-2 mb-4"},[_vm._v("Документы кандидата")]),(_vm.results && _vm.generalInfo)?_c('div',[_c('DossierTable')],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }